//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductDocumentItem from "~/components/product/main-product-card/ProductDocumentItem";

export default {
  name: "SectionDescriptionDocuments",

  data: function () {
    return {
      activeTab: "description",
      isSmallDescription: false,
      isShowButtonMoreDescription: false
    }
  },

  components: {
    DescriptionProductCard: () => import('~/components/product/main-product-card/DescriptionProductCard'),
    ProductDocumentItem
  },

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  computed: {
    tabs: function () {
      return [
        {label: "Описание", value: "description"},
        {label: "Документы", value: "documents", disabled: !this.isShowDocumentsTab},
        {label: "Как читать рецепт?", value: "how-read-recipe", disabled: !Boolean(this.howReadRecipe)},
        {label: "Возврат товара", value: "purchase-returns"},
      ]
    },

    isShowDocumentsTab() {
      return Boolean(this.getDocumentsList.length > 0)
    },

    getDocumentsList() {
      return this.product?.files || [];
    },
    howReadRecipe: function () {
      const characteristics = this.product?.characteristics?.[0]?.characteristics || [];

      return characteristics.find((t) => t.slug === "prescription-contact-lenses")?.values?.[0]?.value
    },


    additionalTextDescription: function () {
      return this.product?.dynamicFields?.additional_description || ""
    }
  },

  mounted: function () {
    this.initFunctionMoreDescription();
  },

  methods: {
    changeActiveTab: function (activeTab) {
      this.activeTab = activeTab;
    },

    initFunctionMoreDescription: function () {
      const fullHeight = this.$refs.refDescription.getBoundingClientRect();

      if (fullHeight.height <= 66) {
        return
      }

      this.isShowButtonMoreDescription = true;
      this.isSmallDescription = true;
    },
    changeSmallDescription: function () {
      this.isSmallDescription = !this.isSmallDescription;
    }
  }
}
